export const classes = {
  dialog: 'w-[95vw] max-w-[900px] h-[80vh] relative px-0',
  title:
    'absolute top-0 left-0 right-0 z-10 pl-6 pr-4 pt-2 pb-0 bg-transparent',
  body: 'h-full p-0 overflow-hidden',
  sceneWrapper:
    'relative w-full h-full bg-grey-2 dark:bg-white/[0.06] rounded-2xl',
  scene: 'w-full h-full',
  // Inset the document and its floating controls below the floating title
  pdfViewer: 'size-full pt-14',
  pdfControls: 'top-14',
  message:
    'absolute inset-0 place-center text-grey-7 dark:text-mauve-2 text-base pointer-events-none',
};
